module.exports = __webpack_public_path__ + "img/aquila.6a3846f6.png";